import { Component, Input, OnChanges, SimpleChanges, SimpleChange } from "@angular/core";

@Component({
    selector: "edp-avatar",
    templateUrl: "./edp-avatar.component.html",
    styleUrls: ["./edp-avatar.component.scss"],
})
export class EdpAvatarComponent implements OnChanges {
    @Input() url: string;
    @Input() alt: string;
    @Input() isResponsive = true;

    showImage = false;
    private _url: string;

    ngOnChanges(changes: SimpleChanges) {
        const newUrl: SimpleChange = changes.url;
        this._url = newUrl.currentValue;
        this.showImage = this.checkURL(this._url);
    }

    checkURL = (url: string) => {
        if (url) {
            this.showImage = (url.match(/\.(jpeg|jpg|gif|png|svg)$/i) != null);
        }
        return this.showImage;
    }
}
